import BaseWrapper from "../../components/ui/BaseWrapper";

const FreelanceCompaniesListingHeader = () => {
  return (
    <div className="border-b border-zinc-300 bg-white">
      <BaseWrapper>
        <div className="py-[7px] flex justify-between">
          <h3 className="font-light">Vendors</h3>
        </div>
      </BaseWrapper>
    </div>
  );
};

export default FreelanceCompaniesListingHeader;
